import styled from 'styled-components'

export const Root = styled.div`
  flex: 1;
  max-width: 965px;
  width: 100%;
  margin: 0 auto;
  padding: 15px 15px 40px;
  @media screen and (max-width: 768px) {
    padding-top: 80px;
  }
`
